import React, {useCallback} from 'react';
import {DescriptionOutlined, Search} from "@material-ui/icons";
import IframeModal from "./shared/iframemodal/IframeModal";
import useDialogState from "../hooks/useDialogState";
import {URL_BOLETO} from "../constants";
import Button from "@material-ui/core/Button";
import {makeStyles} from "@material-ui/core";
import useLoading from "../hooks/useLoading";
import {containedButton} from "../utils/styles";

const useStyles = makeStyles(theme => ({
    ...containedButton(theme, false, false)
}));

export default function ButtonBoleto(props) {
    const {
        boleto,
        disabled
    } = props;
    const classes = useStyles();
    const setLoading = useLoading();
    const {
        dialogState,
        openDialog,
        closeDialog
    } = useDialogState({
        boleto: false
    });

    const onClick = useCallback(() => {
        setLoading(true);

        openDialog('boleto')();
    }, []);

    return (
        <>
            <Button
                variant='contained'
                className={classes.containedButton}
                startIcon={<DescriptionOutlined />}
                onClick={onClick}
                disabled={disabled}>
                Boleto
            </Button>
            <IframeModal
                open={dialogState.boleto}
                onClose={closeDialog('boleto')}
                onLoad={() => setLoading(false)}
                title='Boleto'
                url={URL_BOLETO + boleto} />
        </>
    );
}